import { BaseService } from "./baseService";
import type { ActivationCode } from "@zhihaoscm/entity";
import httpRequest from "./index";
import { EXCHANGE_STATE } from "../../../../common/enum/activition";
import { MEMBER_LEVEL } from "../../../../common/enum/member";
import { notifyRequestError, notifySuccess, notifyWarning } from "@/api/runtime";

export class ActivationService extends BaseService<any, any, any, any> {
    // 查询卡券列表
    public async getActivations(): Promise<ActivationCode[]> {
        const { data } = await this.service.get(`${this.path}/find/customer`);
        return data;
    }

    /**兑换卡券 */
    public async exchange(code: string): Promise<boolean> {
        const {
            data
        }: {
            data: {
                activationCode: ActivationCode;
                errorCode: number;
            };
        } = await this.service.get(`${this.path}/exchange`, { params: { code } });
        switch (data.errorCode) {
            case EXCHANGE_STATE.REDEMPTION_SUCCESS.code:
                notifySuccess(
                    `${EXCHANGE_STATE.getIntroByCode(data.errorCode)}! 您已成功兑换${MEMBER_LEVEL.getIntroByCode(data.activationCode.level)}${data.activationCode.duration}天`
                );
                return true;
            case EXCHANGE_STATE.REDEMPTION_FAILED.code:
                notifyRequestError(
                    `${EXCHANGE_STATE.getIntroByCode(data.errorCode)}! ${EXCHANGE_STATE.getStateByCode(data.errorCode)}`
                );
                return false;
            case EXCHANGE_STATE.ACTIVATION_FAILED.code:
            case EXCHANGE_STATE.ACTIVATION_CODE_INVALID.code:
            case EXCHANGE_STATE.REDEMPTION_CLOSED.code:
                notifyWarning(
                    `${EXCHANGE_STATE.getIntroByCode(data.errorCode)}! ${EXCHANGE_STATE.getStateByCode(data.errorCode)}`
                );
                return false;
            default:
                return false;
        }
    }
    /**兑换卡券 */
    public async useActiveCode(code: string): Promise<any> {
        const {
            data
        }: {
            data: {
                activationCode: ActivationCode;
                errorCode: number;
            };
        } = await this.service.get(`${this.path}/exchange`, { params: { code } });
        return data;
    }
}
export const activationService = new ActivationService("/activation/code", httpRequest);
